__turbopack_context__.v({
  "tip": "Tip-module__6ByaNW__tip",
  "tipIcon": "Tip-module__6ByaNW__tipIcon",
});
